import React from "react";
import Moment from 'moment';

export const Validator = {
  handleDateToString: function (dateString) {
    Moment.locale('en');
    return Moment(dateString).format('DD/MM/YYYY')
  },
  handleDateObjectToString: function (date, format) {
    Moment.locale('en');
    return Moment(date).format(format)
  },
  isNullOrEmptyValue: function (text) {
    return text ? true : false
  },
  isValidEmail: function (email) {
    return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  },
  isValidPassword: function (password) {
    return String(password)
    .match(
      /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,16}$/
    );
  }

}

export default Validator;